<template>
  <div class="newdetail">
    <header> 文章详情</header>
    <div class="detailCon">
      <h3 class="page-article-title">{{article.title}}</h3>
      <p class="page-article-time">{{article.relaseDate}}</p>
      <div class="page-article-content" v-html="article.articleContent">
      </div>
    </div>
  </div>

</template>

<script>
  import config from '../../assets/js/config.js'
  export default{
    name:'companyDetail',
    data(){
      return{
        article:{},
        id:this.$route.query.id
      }
    },
    mounted(){
      this.getNewsDetail();
    },
    methods:{
      getNewsDetail(){
        var that=this;
        that.$ajax.post(config.caseResults.caseDetail, JSON.stringify({"id":this.id}))
          .then(function (response) {
            let details = response.data.data.article;
                if(details){
                  details.articleContent = details.articleContent.replace(/\/?u\//ig,'http://back.citgroup.cn/u/');
                  details.articleContent = details.articleContent.replace(/<img /ig,'<img style="width:98%;float:left;margin:1%;"');
                  that.article=details;
                }
          })
      }
    }

  }

</script>

<style scoped>
  .newdetail{
    margin-bottom: 1rem;
  }
  header{
    text-align: center;
    font-size: 0.24rem;
    font-weight: 400;
    height: 0.6rem;
    line-height: 0.6rem;
    background: #efefef;
  }
  .detailCon{
    padding-bottom: 3.2rem;
  }
  .page-article-title{
    text-align: left;
    font-size: 0.30rem;
    font-weight: 700;
    padding: 0.3rem 0.2rem 0;
    line-height: 0.5rem;
  }
  .page-article-time{
    text-align: right;
    padding-right: 0.24rem;
    font-size: 0.24rem;
    color: #666;
    border-bottom: 1px dotted #ddd;
    margin:0.02rem 0.14rem;
    padding-bottom:0.14rem;
  }

  .page-article-content{
    text-align: left;
    text-indent:2em ;
    padding: 0.1rem 0.14rem;
    font-size: 0.24rem;
    line-height: 0.4rem;
    color: #777;
  }
</style>



// WEBPACK FOOTER //
// src/components/caseResults/caseDetail.vue